<script>
    import VueFormGenerator from 'vue-form-generator';
    import formGroup from './formGroup.vue';
    import formMixin from 'vue-form-generator/src/formMixin.js';

    export default {
        extends: VueFormGenerator.component,
        components: { formGroup },
        mixins: [formMixin],
    };
</script>



// WEBPACK FOOTER //
// src/core/Form/vfg/formGenerator.vue